import React, { Fragment } from 'react'
import { useNavigate } from 'react-router-dom';

import { StudentImmigrationTab } from '../../../../interfaces/student';
import { IPassportDetail } from '../../../../interfaces/services';
import PassportForm from '../../forms/PassportForm';

interface IPassportProps {
    studentId: number;
    setCurrentTab: (tab: StudentImmigrationTab) => void;
    passports: IPassportDetail[];
}

const Passport = (props: IPassportProps) => {
    const navigate = useNavigate();

    const { setCurrentTab, passports, studentId } = props;

    const onGoBack = () => {
        navigate(`/students/${studentId}/visa-chances`);
    };

    const onGoNext = () => {
        setCurrentTab('Permit');
    };

    return (
        <div className='immersion__details_form'>
            <div className="immersion__details_form_inputs__container">
                {passports.map((passport, index) => (
                    <Fragment key={index}>
                        <PassportForm
                            studentId={studentId}
                            data={passport}
                        />

                        {index < passports.length - 1 && (
                            <Fragment>
                                <div className="immersion__details_form_inputs__container__divider" />
                                <br />
                                <br />
                            </Fragment>
                        )}

                    </Fragment>
                ))}
            </div>

            <div className="immersion__details_form_actions">
                <button
                    className={`immersion__btn immersion__btn__secondary`}
                    onClick={onGoBack}
                >
                    Go back
                </button>

                <button
                    className={`immersion__btn immersion__btn__primary`}
                    onClick={onGoNext}
                >
                    Next
                </button>
            </div>
        </div>
    )
}

export default Passport;